import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=ca437ba4&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=ca437ba4&prod&scoped=scoped&lang=less"
import style1 from "./Create.vue?vue&type=style&index=1&id=ca437ba4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca437ba4",
  null
  
)

export default component.exports